module.exports = __webpack_public_path__ + "img/70800.8cb2b369.jpg";